import { Route, Routes } from "react-router-dom";
import router from "constant/router";
import React, { Suspense } from "react";
import LoadingSpin from "component/base/Loading";
const NotFound = React.lazy(() => import("./NotFound"));
const Download = React.lazy(() => import("./download"));
const Home = React.lazy(() => import("./home"));
const Policy = React.lazy(() => import("./policy"));
const AtHome = React.lazy(() => import("./at-home"));
const AtTheHospital = React.lazy(() => import("./at-the-hospital"));
const LiveHealthy = React.lazy(() => import("./live-healthy"));
const ListSpecialties = React.lazy(() => import("./list-specialties"));
const ListFacilities = React.lazy(() => import("./list-facilities"));
const DoctorList = React.lazy(() => import("./doctor-list"));
const HealthGuard = React.lazy(() => import("./health-guard"));
const PartnerWithTobecare = React.lazy(() => import("./partner-with-tobecare"));
const CooperateWithTobecare = React.lazy(() =>
  import("./cooperate-with-tobecare")
);
const BusinessDigitalTransformationPackage = React.lazy(() =>
  import("./business-digital-transformation-package")
);
const GeneralExamination = React.lazy(() => import("./general-examination"));
const MedicalTest = React.lazy(() => import("./medical-test"));
const MentalHealth = React.lazy(() => import("./mental-health"));
const DentalCheckup = React.lazy(() => import("./dental-checkup"));
const OutstandingSpecialties = React.lazy(() =>
  import("./outstanding-specialties")
);
const MediaProduct = React.lazy(() => import("./media-product"));
const DetailProduct = React.lazy(() => import("./detail-product"));
const Store = React.lazy(() => import("./store"));
const Profile = React.lazy(() => import("./dashboard/profile"));
const DataDelection = React.lazy(() =>
  import("./dashboard/profile/data-delection")
);
const HelpCenter = React.lazy(() => import("./dashboard/profile/help-center"));
const DailyTasksAndRewards = React.lazy(() =>
  import(
    "./dashboard/profile/help-center/how-to-complete-daily-tasks-and-redeem-rewards"
  )
);
const VoucherAppointment = React.lazy(() =>
  import(
    "./dashboard/profile/help-center/how-to-redeem-voucher-and-make-appointment"
  )
);
const FaucetPoint = React.lazy(() =>
  import("./dashboard/profile/help-center/how-to-get-faucet-points")
);
const ChangePassword = React.lazy(() => import("./dashboard/change-password"));
const Notification = React.lazy(() => import("./dashboard/notification"));
const Appointment = React.lazy(() => import("./dashboard/appointment"));

const DoctorJob = React.lazy(() => import("./dashboard/doctor-job"));
const Wallet = React.lazy(() => import("./dashboard/wallet"));
const ProductOrder = React.lazy(() => import("./dashboard/product-order"));
const MedicalRecords = React.lazy(() => import("./dashboard/medical-records"));
const WalletAddress = React.lazy(() => import("./dashboard/wallet-address"));
const EditProfile = React.lazy(() =>
  import("./dashboard/profile/edit-profile")
);
const Checkout = React.lazy(() => import("./dashboard/checkout"));
const DetailMedicalFacility = React.lazy(() =>
  import("./detail-medical-facility")
);
const RegisterDoctorAccount = React.lazy(() =>
  import(
    "./dashboard/profile/doctor-account-management/register-doctor-account"
  )
);
const UpdateDoctorAccount = React.lazy(() =>
  import("./dashboard/profile/doctor-account-management/update-doctor-account")
);
const Managetimeworking = React.lazy(() =>
  import("./dashboard/profile/work-management/manage-time-working")
);

const ManagingDiscountVouchers = React.lazy(() =>
  import("./dashboard/profile/work-management/managing-discount-vouchers")
);

const CreateVoucher = React.lazy(() =>
  import(
    "./dashboard/profile/work-management/managing-discount-vouchers/create-voucher"
  )
);

const UpdateVoucher = React.lazy(() =>
  import(
    "./dashboard/profile/work-management/managing-discount-vouchers/update-voucher"
  )
);

const UpdateTimeMarker = React.lazy(() =>
  import(
    "./dashboard/profile/work-management/manage-time-working/update-time-marker"
  )
);
const CreateTimeMarker = React.lazy(() =>
  import(
    "./dashboard/profile/work-management/manage-time-working/create-time-marker"
  )
);

const MedicalExaminationPriceManagement = React.lazy(() =>
  import(
    "./dashboard/profile/work-management/medical-examination-price-management"
  )
);

const CreateMedicalExaminationPrice = React.lazy(() =>
  import(
    "./dashboard/profile/work-management/medical-examination-price-management/create-medical-examination-price"
  )
);

const ServicePriceManagement = React.lazy(() =>
  import(
    "./dashboard/profile/work-management/medical-examination-price-management/service-price-management"
  )
);

const CreateServicePrice = React.lazy(() =>
  import(
    "./dashboard/profile/work-management/medical-examination-price-management/create-service-price"
  )
);

const UpdateServicePrice = React.lazy(() =>
  import(
    "./dashboard/profile/work-management/medical-examination-price-management/update-service-price"
  )
);

const UpdateMedicalExaminationPrice = React.lazy(() =>
  import(
    "./dashboard/profile/work-management/medical-examination-price-management/update-medical-examination-price"
  )
);

const FinancialManagement = React.lazy(() =>
  import("./dashboard/profile/financial-management")
);

const CryptocurrencyWalletManagement = React.lazy(() =>
  import(
    "./dashboard/profile/financial-management/cryptocurrency-wallet-management"
  )
);

const DetailDoctorSpecialty = React.lazy(() =>
  import("./detail-doctor-specialty")
);
const DetailDoctor = React.lazy(() => import("./detail-doctor"));
const ManageCooperateMedicalFacility = React.lazy(() =>
  import("./dashboard/manage-cooperate-medical-facility")
);
const CreateMedicalFacility = React.lazy(() =>
  import(
    "./dashboard/manage-cooperate-medical-facility/create-medical-facility"
  )
);
const UpdateMedicalFacility = React.lazy(() =>
  import(
    "./dashboard/manage-cooperate-medical-facility/update-medical-facility"
  )
);

const Relatives = React.lazy(() => import("./dashboard/profile/relatives"));
const AddYourRelatives = React.lazy(() =>
  import("./dashboard/profile/relatives/add-your-relatives")
);
const EditYourRelatives = React.lazy(() =>
  import("./dashboard/profile/relatives/edit-your-relatives")
);

const WorkManagement = React.lazy(() =>
  import("./dashboard/profile/work-management")
);
const DoctorAccountManagement = React.lazy(() =>
  import("./dashboard/profile/doctor-account-management")
);

const HealthCheckBooking = React.lazy(() =>
  import("./dashboard/health-check-booking")
);

const FreeDocConsult = React.lazy(() => import("./free-doctor-consultation"));
const MyHistory = React.lazy(() =>
  import("./free-doctor-consultation/my-history")
);
const AnswerQuestions = React.lazy(() =>
  import("./free-doctor-consultation/list-answer-questions")
);

export default (
  <Suspense fallback={<LoadingSpin />}>
    <Routes>
      <Route path={router.home} element={<Home />} />
      <Route path={router.at_home} element={<AtHome />} />
      <Route path={router.at_the_hospital} element={<AtTheHospital />} />
      <Route path={router.live_healthy} element={<LiveHealthy />} />
      <Route path={router.download} element={<Download />} />
      <Route path={router.list_specialties} element={<ListSpecialties />} />
      <Route path={router.list_facilities} element={<ListFacilities />} />
      <Route path={router.doctor_list} element={<DoctorList />} />
      <Route path={router.health_guard} element={<HealthGuard />} />
      <Route
        path={router.business_digital_transformation_package}
        element={<BusinessDigitalTransformationPackage />}
      />
      <Route
        path={router.cooperate_with_tobecare}
        element={<CooperateWithTobecare />}
      />
      <Route
        path={router.partner_with_tobecare}
        element={<PartnerWithTobecare />}
      />
      <Route
        path={router.general_examination}
        element={<GeneralExamination />}
      />
      <Route path={router.medical_test} element={<MedicalTest />} />
      <Route path={router.mental_health} element={<MentalHealth />} />
      <Route path={router.dental_checkup} element={<DentalCheckup />} />
      <Route
        path={`${router.outstanding_specialties}/:detailDoctorSId`}
        element={<OutstandingSpecialties />}
      />
      <Route path={router.media_product} element={<MediaProduct />} />
      <Route
        path={`${router.detail_product}/:productId`}
        element={<DetailProduct />}
      />
      <Route path={`${router.store}/:storeId`} element={<Store />} />
      <Route
        path={`${router.detail_doctor}/:doctorId`}
        element={<DetailDoctor />}
      />
      <Route
        path={`${router.detail_doctor_specialty}/:detailDoctorSId`}
        element={<DetailDoctorSpecialty />}
      />
      <Route path={router.profile} element={<Profile />} />
      <Route
        path={router.doctor_account_management}
        element={<DoctorAccountManagement />}
      />
      <Route
        path={`${router.health_check_booking}/:bookingHealthId`}
        element={<HealthCheckBooking />}
      />
      <Route path={router.work_management} element={<WorkManagement />} />
      <Route path={router.relatives} element={<Relatives />} />
      <Route
        path={`${router.add_your_relatives}`}
        element={<AddYourRelatives />}
      />
      <Route
        path={`${router.edit_your_relatives}/:relationshipId`}
        element={<EditYourRelatives />}
      />
      <Route path={router.changePassword} element={<ChangePassword />} />
      <Route path={router.notification} element={<Notification />} />
      <Route path={router.appointment} element={<Appointment />} />
      <Route path={router.doctor_job} element={<DoctorJob />} />
      <Route path={router.wallet} element={<Wallet />} />
      <Route path={router.product_order} element={<ProductOrder />} />
      <Route path={router.checkout} element={<Checkout />} />
      <Route path={router.medical_records} element={<MedicalRecords />} />
      <Route path={router.wallet_address} element={<WalletAddress />} />
      <Route path={router.edit_profile} element={<EditProfile />} />
      <Route path={router.help_center} element={<HelpCenter />} />
      <Route path={router.data_delection} element={<DataDelection />} />
      <Route
        path={router.how_to_complete_daily_tasks_and_redeem_rewards}
        element={<DailyTasksAndRewards />}
      />
      <Route
        path={router.how_to_redeem_voucher_and_make_appointment}
        element={<VoucherAppointment />}
      />
      <Route path={router.faucet_point} element={<FaucetPoint />} />
      <Route
        path={router.register_doctor_account}
        element={<RegisterDoctorAccount />}
      />
      <Route
        path={router.update_doctor_account}
        element={<UpdateDoctorAccount />}
      />
      <Route
        path={router.manage_time_working}
        element={<Managetimeworking />}
      />
      <Route
        path={router.managing_discount_vouchers}
        element={<ManagingDiscountVouchers />}
      />
      <Route path={router.create_voucher} element={<CreateVoucher />} />
      <Route
        path={`${router.update_voucher}/:updateVoucherId`}
        element={<UpdateVoucher />}
      />
      <Route
        path={`${router.update_time_marker}/:updateTimeMarkerId`}
        element={<UpdateTimeMarker />}
      />
      <Route path={router.create_time_marker} element={<CreateTimeMarker />} />
      <Route
        path={router.medical_examination_price_management}
        element={<MedicalExaminationPriceManagement />}
      />
      <Route
        path={router.create_medical_examination_price}
        element={<CreateMedicalExaminationPrice />}
      />
      <Route
        path={`${router.service_price_management}/:ServicePriceId`}
        element={<ServicePriceManagement />}
      />
      <Route
        path={`${router.create_service_price}/:ServicePriceId`}
        element={<CreateServicePrice />}
      />
      <Route
        path={`${router.update_service_price}/:ServicePriceId`}
        element={<UpdateServicePrice />}
      />
      <Route
        path={`${router.update_medical_examination_price}/:MEPriceId`}
        element={<UpdateMedicalExaminationPrice />}
      />
      <Route
        path={router.financial_management}
        element={<FinancialManagement />}
      />
      <Route
        path={router.cryptocurrency_wallet_management}
        element={<CryptocurrencyWalletManagement />}
      />
      <Route
        path={`${router.detail_medical_facility}/:facilityId`}
        element={<DetailMedicalFacility />}
      />
      <Route
        path={router.manage_cooperate_medical_facility}
        element={<ManageCooperateMedicalFacility />}
      />{" "}
      <Route
        path={router.create_medical_facility}
        element={<CreateMedicalFacility />}
      />
      <Route
        path={`${router.update_medical_facility}/:detailFacilityId`}
        element={<UpdateMedicalFacility />}
      />
      <Route
        path={router.free_doctor_consultation}
        element={<FreeDocConsult />}
      />
      <Route path={router.my_history} element={<MyHistory />} />
      <Route
        path={router.list_answer_questions}
        element={<AnswerQuestions />}
      />
      {/* <Route path={router.Policy} element={<Policy />} /> */}
      <Route path={router.PrivacyPolicy} element={<Policy />} />
      <Route path={router.TemrsOfService} element={<Policy />} />
      {/* 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  </Suspense>
);
